import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { action } from '@ember/object';
import { replace } from '@square/dashboard-utilities/utils/window';
import { generateSavingsAccountUrl } from '@banking/ui/utils/savings-account-url';

export default class SplashController extends Controller {
  @service currentApplicationFlow;
  @service router;

  @readOnly('currentApplicationFlow.bankcBalanceId')
  bankcBalanceId;

  @action
  continue() {
    this.router.transitionTo('signup.automation.withholding');
  }

  @action
  goToGeneralSavings() {
    const url = generateSavingsAccountUrl(this.bankcBalanceId);
    replace(url);
  }
}
